export enum TaskRecurrenceType {
    Hourly = 'HOURLY',
    Weekly = 'WEEKLY',
    Monthly = 'MONTHLY',
    Yearly = 'YEARLY',
}
